import { Routes, Route, Navigate } from 'react-router-dom';
import { RulesetLayout } from './components/layout/RulesetLayout';
import { BuilderLayout } from './components/layout/BuilderLayout';
import { RulesetPickerPage } from './pages/RulesetPickerPage';
import { RulesetLandingPage } from './pages/RulesetLandingPage';
import { CreateCharacterPage } from './pages/CreateCharacterPage';
import { CharacterSheetPage } from './pages/CharacterSheetPage';
import { CharacterLibraryPage } from './pages/CharacterLibraryPage';
import { PlayModePage } from './pages/PlayModePage';
import { BrowseRacesPage } from './pages/BrowseRacesPage';
import { BrowseClassesPage } from './pages/BrowseClassesPage';
import { SpellsReferencePage } from './pages/SpellsReferencePage';
import { WeaponsGearPage } from './pages/WeaponsGearPage';
import { ConditionsReferencePage } from './pages/ConditionsReferencePage';
import { FeatsReferencePage } from './pages/FeatsReferencePage';
import { BeastsReferencePage } from './pages/BeastsReferencePage';
import { FightingStylesReferencePage } from './pages/FightingStylesReferencePage';
import { IntroToIgnusPage } from './pages/IntroToIgnusPage';
import { GeographyPage } from './pages/GeographyPage';
import { FactionsPage } from './pages/FactionsPage';
import { MagicPage } from './pages/MagicPage';
import { GlobalDiceRoller } from './components/GlobalDiceRoller';

export function App() {
  return (
    <>
      <Routes>
      {/* Root: Ruleset Picker */}
      <Route path="/" element={<RulesetPickerPage />} />

      {/* Character builder - separate layout (minimal padding) */}
      <Route path="/:ruleset/create" element={<BuilderLayout />}>
        <Route index element={<CreateCharacterPage />} />
      </Route>

      {/* Play Mode - standalone layout */}
      <Route path="/:rulesetId/play" element={<PlayModePage />} />

      {/* Ruleset-scoped routes (standard layout) */}
      <Route path="/:ruleset" element={<RulesetLayout />}>
        {/* Landing page */}
        <Route index element={<RulesetLandingPage />} />

        {/* Ignus Lore Pages */}
        <Route path="intro" element={<IntroToIgnusPage />} />
        <Route path="geography" element={<GeographyPage />} />
        <Route path="factions" element={<FactionsPage />} />
        <Route path="magic" element={<MagicPage />} />

        {/* Character sheet */}
        <Route path="character/:id" element={<CharacterSheetPage />} />

        {/* Character Library */}
        <Route path="library" element={<CharacterLibraryPage />} />

        {/* Reference pages */}
        <Route path="races" element={<BrowseRacesPage />} />
        <Route path="classes" element={<BrowseClassesPage />} />
        <Route path="spells" element={<SpellsReferencePage />} />
        <Route path="weapons-gear" element={<WeaponsGearPage />} />
        <Route path="conditions" element={<ConditionsReferencePage />} />
        <Route path="feats" element={<FeatsReferencePage />} />
        <Route path="beasts" element={<BeastsReferencePage />} />
        <Route path="fighting-styles" element={<FightingStylesReferencePage />} />
      </Route>

      {/* Catch-all: redirect to ruleset picker */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>

      {/* Global Dice Roller - available on all pages */}
      <GlobalDiceRoller />
    </>
  );
}
